/**
 * Show google map with clickable lat long point for choosing a start point etc
 */
admin.registerLoad(function (prefix) {
    $(prefix + '.js-rating').each(function () {
        var input = $($(this).data("input"));
        var stars_container = $($(this).data("stars"));

        noUiSlider.create($(this)[0], {
            start: [$(this).data("value")],
            step: 1,
            connect: false,
            range: {
                'min': $(this).data("min"),
                'max': $(this).data("max")
            }
        });

        $(this)[0].noUiSlider.on('update', function ( values, handle ) {
            var value = values[handle];
            input.val(Math.round(value));

            var value = Math.round(value);

            var is_half = (Math.round(value) % 2 != 0);
            var stars = Math.floor(value/2);
            var blanks = is_half ? 4 - stars : 5 - stars;

            var output = "";

            for (var i = 0 ; i < stars ; i++)
            {
                output += "<i class='glyphicon glyphicon-star'></i>";
            }

            if (is_half)
            {
                output += "<i class='glyphicon glyphicon-star half'></i>";
            }

            for (var i = 0 ; i < blanks ; i++)
            {
                output += "<i class='glyphicon glyphicon-star-empty'></i>";
            }

            stars_container.html(output);
        });
        //var handle = $(this).find('.ui-slider-handle');

        /*$(this).slider({
            range: "min",
            value: $(this).data("value"),
            min: $(this).data("min"),
            max: $(this).data("max"),
            create: function() {
                handle.text( $( this ).slider( "value" ) );
            },
            slide: function( event, ui ) {
                handle.text( ui.value );
            }
        });*/
    });
});